import { useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./header";
import Nav from "./nav";
import palette from "../../theme/palette";
import { Typography } from "@mui/material";
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",

  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
  },
}));

const Footer = styled("div")(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: palette.grey[300],
  padding: 15,
  marginTop: "auto",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  let year = new Date().getFullYear();
  return (
    <>
      <StyledRoot>
        <Header onOpenNav={() => setOpen(true)} />

        <Nav openNav={open} onCloseNav={() => setOpen(false)} />

        <Main>
          <Outlet />
          <Footer>
            <Typography>
              Copyright© {year} EventPrix LLC. All Rights Reserved.
            </Typography>
          </Footer>
        </Main>
      </StyledRoot>
    </>
  );
}
